import { formatDate, DATE_FORMATS } from '@frontend/mwm-ui'
import { MdEdit } from 'react-icons/md'

import type { ReactElement } from 'react'
import type { ITodolistFlow } from '~/types/todolist'

import { TodolistStatusBadge } from '~/components/Badges'
import Button from '~/components/Buttons/Button'
import UserCard from '~/components/UserCard'
import { TODOLIST_TASK_STATUS } from '~/types/todolist'

import './styles.scss'

type UserCardInfo = {
  date: number
  name: string
  picture?: string
}

interface Props {
  createdBy?: UserCardInfo
  onEditTodo: VoidFunction
  todolistFlow: ITodolistFlow
  updatedBy?: UserCardInfo
}

const TodoDetailsHeader = ({ createdBy, onEditTodo, todolistFlow, updatedBy }: Props): ReactElement => {
  /** Local state */

  const status = todolistFlow.tasks.some((task) => task.status === TODOLIST_TASK_STATUS.IN_PROGRESS)
    ? TODOLIST_TASK_STATUS.IN_PROGRESS
    : TODOLIST_TASK_STATUS.DONE

  /** Render */

  return (
    <div className="todolist-details-header">
      <div className="flex-row-container">
        <div className="title-container">
          <div className="title-container__title">{todolistFlow.todolist.title}</div>
          <TodolistStatusBadge value={status} />
        </div>
        <Button className="edit-button" onClick={onEditTodo} outlined size="small">
          <MdEdit color="#ff5301" size={14} />
          Edit
        </Button>
      </div>
      <div className="flex-row-container">
        <div className="column">
          {createdBy ? (
            <UserCard
              label="Created by"
              name={createdBy.name}
              picture={createdBy.picture}
              size="small"
              subInfo={formatDate(createdBy.date, DATE_FORMATS.DEFAULT_WITH_HOURS)}
            />
          ) : null}
        </div>
        <div className="column">
          {updatedBy ? (
            <UserCard
              label="Last update by"
              name={updatedBy.name}
              picture={updatedBy.picture}
              size="small"
              subInfo={formatDate(updatedBy.date, DATE_FORMATS.DEFAULT_WITH_HOURS)}
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default TodoDetailsHeader
